import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable()
export class AccordionInventaireService {

  private accordionInventaireActionSource = new Subject<boolean>();
  accordionInventaireAction$ = this.accordionInventaireActionSource.asObservable();

  triggerExpandAll() {
    this.accordionInventaireActionSource.next(true);
  }

  triggerCollapseAll() {
    this.accordionInventaireActionSource.next(false);
  }
}
